import * as Sentry from '@sentry/react';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import type { IO } from 'fp-ts/lib/IO';
import * as TE from 'fp-ts/lib/TaskEither';
import * as T from 'fp-ts/Task';

import { UnknownError } from '../api/RestService';
import type { BSTask } from '../model/types';

export const BSTaskFromIO = <A>(io: IO<A>): BSTask<A> =>
  pipe(
    TE.fromIO(io),
    TE.mapLeft(() => {
      Sentry.captureMessage('BSTaskFromIO unknown error', {
        extra: {
          io,
        },
        level: 'error',
      });

      return UnknownError;
    }),
  );

export const BSTaskVoid: BSTask<void> = BSTaskFromIO(() => {});

export function ignoreTaskEither<A, E>(t: TE.TaskEither<E, A>): T.Task<void> {
  return pipe(
    t,
    T.map(
      E.fold(
        () => {},
        () => {},
      ),
    ),
  );
}

export const executeTask = async <A>(task: T.Task<A>) => {
  await task();
};
